import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayFilter',
  standalone: true
})
export class ArrayFilterPipe implements PipeTransform {

  public transform<T>(arr: T[], cb: (x: T) => boolean): T[] {
    return arr.filter(v => cb(v));
  }
}
